import DatasetTable from "admin/components/DatasetTable";
import { DATASET_MANAGEMENT_PAGE_TITLE } from "admin/types/constants/page-titles";
import { AlertTriangle } from "lucide-react";
import { Alert, AlertDescription } from "~/components/ui/alert";
import useAppHeader from "~/contexts/header";
import { useDocumentTitle } from "~/hooks/useDocumentTitle";
import { NEXTGEN_MAX_CONTENT_WIDTH } from "~/lib/layout";

const Datasets = ({ isNextGen = false }: { isNextGen?: boolean }) => {
  const maxContentWidth = isNextGen ? NEXTGEN_MAX_CONTENT_WIDTH : undefined;
  const maxContentWidthStyle = maxContentWidth
    ? { maxWidth: maxContentWidth, margin: "0 auto" }
    : undefined;

  useDocumentTitle(DATASET_MANAGEMENT_PAGE_TITLE);
  useAppHeader({ title: DATASET_MANAGEMENT_PAGE_TITLE });

  return (
    <div className="h-full flex flex-col">
      <div
        className="flex w-full flex-col space-y-6 pt-6 pb-8 px-6 shrink-0"
        style={maxContentWidthStyle}
      >
        <div className="flex items-start justify-between">
          <div className="space-y-2">
            <h1 className="text-[30px] font-semibold leading-[36px] tracking-[0.4px] text-foreground">
              Dataset Admin
            </h1>
            <Alert variant="warning">
              <AlertTriangle />
              <AlertDescription>
                <p>
                  You are now using your Dataset Admin privileges to manage datasets. This page
                  allows you to escalate your own permissions on tables and files that you do not
                  otherwise have access to. <b>Please use this power responsibly.</b>
                </p>
              </AlertDescription>
            </Alert>
          </div>
        </div>
      </div>

      <div className="flex w-full flex-1 flex-col px-6 pb-6" style={maxContentWidthStyle}>
        <DatasetTable isNextGen={isNextGen} />
      </div>
    </div>
  );
};

export default Datasets;
